import { RouterProvider } from "react-router-dom"

import { router } from "./router-config"

export const ReactRouterProvider = () => {
  return <RouterProvider router={router} />
}
